export default "__VITE_ASSET__CJ5mamzN__"